module.exports = __webpack_public_path__ + "static/media/pessoas.e36960c0.png";